import { createCase } from "api/actions/VisitActions";
import { CURRENT_SOURCE } from "helpers/currentSource";
import {
  dermatology_main_steps,
  dermatology_sub_steps,
  speciality,
  step_status,
} from "helpers/enum";
import { useApiMutation } from "hooks/useApiMutation";
import useToastify from "hooks/useToastify";
import { useDermatologyVisitFlow } from "hooks/useVisitFlow";
import useVisitStepChange from "hooks/useVisitStepChange";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { dermaVisitFlowReducers } from "reducers/dermatology/dermaVisitFlowReducer";
import useIncompleteData from "./useIncompleteData";

function useCreateDermatologyVisit() {
  const dispatch = useDispatch();
  const { showAlert } = useToastify();
  const { setLoading } = useVisitStepChange();
  const { currentScreen, subSteps } = useDermatologyVisitFlow();
  const { mutate: callCreateCase, loading: creatingVisit } = useApiMutation(
    createCase
  );
  const { fetchIncompleteData, fetchingIncompleteData } = useIncompleteData();

  useEffect(() => {
    if (creatingVisit || fetchingIncompleteData) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [creatingVisit, setLoading, fetchingIncompleteData]);

  async function createNewVisit({
    patient_id,
    change_current_screen,
    screen_to_complete,
    callBack,
  }) {
    const payload = {
      case: {
        meta: {
          progress_percentage: 2,
        },
        speciality: speciality.dermatology,
        dermatology_steps: {
          main_steps: {
            [dermatology_main_steps.basic_info]: "current",
          },
          sub_steps: {
            [dermatology_sub_steps.select_patient]: "current",
          },
        },
        affected_body_parts: [],
        allergies: [],
        medications: [],
        patient_id: patient_id,
        pharmacy_details: {},
        skin_care_products: [],
        visit_start_source: CURRENT_SOURCE,
      },
    };
    try {
      const result = await callCreateCase(payload);
      if (result && result.error === false) {
        const incompleteDataResponse = await fetchIncompleteData(
          speciality.dermatology
        );
        if (incompleteDataResponse) {
          if (screen_to_complete) {
            dispatch(
              dermaVisitFlowReducers?.[screen_to_complete]({
                status: step_status.completed,
              })
            );
          }
          callBack();
          if (change_current_screen) {
            dispatch(
              dermaVisitFlowReducers.currentScreen({
                value: subSteps?.[currentScreen]?.nextScreen,
              })
            );
          }
        }
      } else {
        showAlert(
          result?.payload?.error_message ?? "Something went wrong",
          "error"
        );
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }

  return { createNewVisit, creatingVisit };
}

export default useCreateDermatologyVisit;
